import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation upsertOrganizationAdmin($id: String!, $data: updateUserInput!) {
    upsertOrganizationAdmin(id: $id, data: $data) {
      id
      status
      error {
        statusCode
        message
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const upsertOrganizationAdminRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.UpdateUserInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'user/upsert_organization_admin',
  async (
  params: {id: String;data: TYPES.UpdateUserInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.upsertOrganizationAdmin;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const upsertOrganizationAdminSlice = createSlice({
  name: 'upsert_organization_admin',
  initialState: initialState,
  reducers: {
    upsertOrganizationAdminClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(upsertOrganizationAdminRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(upsertOrganizationAdminRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(upsertOrganizationAdminRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { upsertOrganizationAdminClear } =
upsertOrganizationAdminSlice.actions;

export const upsertOrganizationAdmin = createSelector(
  (state: RootState) => state.user.upsertOrganizationAdmin.result,
  (state: RootState) => state.user.upsertOrganizationAdmin.error,
  (state: RootState) => state.user.upsertOrganizationAdmin.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default upsertOrganizationAdminSlice.reducer;